import Box from '@mui/material/Box';
import { ComponentProps, type ElementType } from 'react';

import { getColor, Typography } from '../Typography/Typography';

export const TypographyIcon = ({
  icon: Icon,
  children,
  iconPosition = 'left',
  ...rest
}: {
  icon: ElementType;
  iconPosition?: 'left' | 'right';
} & ComponentProps<typeof Typography>) => {
  const iconElement = (
    <Box
      component="span"
      sx={({ palette }) => ({
        alignItems: 'center',
        display: 'inline-flex',
        ml: iconPosition === 'right' ? 0.5 : 0,
        mr: iconPosition === 'left' ? 0.5 : 0,
        svg: {
          fill: getColor(rest.color, palette),
          fontSize: 'inherit',
        },
        verticalAlign: 'middle',
      })}
    >
      <Icon fontSize="inherit" />
    </Box>
  );

  return (
    <Typography component="span" {...rest} sx={{ alignItems: 'center', display: 'inline-flex', ...rest.sx }}>
      {iconPosition === 'left' && iconElement}
      {children}
      {iconPosition === 'right' && iconElement}
    </Typography>
  );
};
